import { useTranslation } from 'react-i18next';
import { GUIDE_SECTIONS } from './guideContent';
import { useGuideStore } from '../../stores/guideStore';
import styles from './GuidePanel.module.css';

function renderBody(text: string) {
  return text.split('\n\n').map((paragraph, i) => {
    // Convert **bold** to <strong>
    const parts = paragraph.split(/\*\*(.*?)\*\*/g);
    return (
      <p key={i}>
        {parts.map((part, j) =>
          j % 2 === 1 ? <strong key={j}>{part}</strong> : part
        )}
      </p>
    );
  });
}

export function GuideArticle() {
  const { t } = useTranslation('guide');
  const activeArticleId = useGuideStore((s) => s.activeArticleId);
  const setActiveArticle = useGuideStore((s) => s.setActiveArticle);

  if (!activeArticleId) return null;

  let article = null;
  for (const section of GUIDE_SECTIONS) {
    article = section.articles.find((a) => a.id === activeArticleId);
    if (article) break;
  }

  if (!article) return null;

  const body = t(article.bodyKey, '');

  return (
    <div className={styles.articleView}>
      <button className={styles.backBtn} onClick={() => setActiveArticle(null)}>
        &larr; {t('common:back', 'Back')}
      </button>
      <h2 className={styles.articleTitle}>{t(article.titleKey)}</h2>
      <div className={styles.articleBody}>
        {renderBody(body)}
      </div>
    </div>
  );
}
